import React, {useState, useEffect} from 'react';
import Time from '../../Time';
import '../../css/App.css';
import '../../css/bootstrap.min.css';
import bootstrap, { Alert } from 'bootstrap';
import Permissions from '../../Permissions';
import AlertWindow from '../../Alert';

class EditUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listOfGroups:[],
      userPermissions:'',
      password:'',
      alertWindow:""
    }
    this.getPermissions = this.getPermissions.bind(this)
    this.addRemovePermission = this.addRemovePermission.bind(this)
    this.handleFormChange = this.handleFormChange.bind(this)
    this.saveChanges = this.saveChanges.bind(this)
    this.closeAlertWindow = this.closeAlertWindow.bind(this)
  }

  componentDidMount(){
    this.getPermissions();
  }

  getPermissions = async() =>{
    let permissionsArray = await Permissions.getAllPermissions();
    this.setState({listOfGroups:permissionsArray})
    this.setState({userPermissions:this.props.permissions})
    return permissionsArray;
  }

  addRemovePermission = (e) => {
    
    let permissionString = this.state.userPermissions;
    console.log()
    let permissionsArray = permissionString.split(',')
  
    if(e.target.checked){
      //If the person already have this permission adds this to the array
      permissionsArray.push(e.target.id)
      console.log(permissionsArray)
      this.setState({userPermissions:permissionsArray.toString()})

    }else{
      //In case the person does not have this permission yet, it adds to the array
      let positionToRemove = permissionsArray.indexOf(e.target.id)
      console.log(positionToRemove)
      permissionsArray.splice(positionToRemove,1)
      console.log(permissionsArray)
      this.setState({userPermissions:permissionsArray.toString()})
    }

  }

  handleFormChange = (e) =>{
    this.setState({[e.target.id]: e.target.value});
  }

  saveChanges = (e) =>{
    e.preventDefault();

    console.log(this.state.password)
    console.log(this.state.userPermissions)

    var formdata = new FormData();
    formdata.append("id", this.props.id);
    formdata.append("password", this.state.password);
    formdata.append("permissions", this.state.userPermissions);

    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    fetch("https://dashboard.realsexdoll.info/php/users/updateuser.php", requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .catch(error => console.log('error', error));

      this.openAlertWindow('User updated!')

  }

  closeAlertWindow = ()=>{
    this.setState({alertWindow:''});
    this.props.close();
  }

  openAlertWindow = (message) =>{
    this.setState({alertWindow:message});
  }


  render() {

    let permissionString = this.props.permissions;

    let listOfGroups;
    if(this.state.listOfGroups.length > 0){
      listOfGroups = this.state.listOfGroups.map((group,i)=>
        <div className='col-4'key={i}>
          <div class="form-check">
              {permissionString.split(',').indexOf(group.groupName)>-1 &&
                <input onChange={this.addRemovePermission} class="form-check-input" defaultChecked={true} permission={group.groupName} type="checkbox" id={group.groupName}></input>
              }
              {permissionString.split(',').indexOf(group.groupName) == -1 &&
                <input onChange={this.addRemovePermission} class="form-check-input" defaultChecked={false} permission={group.groupName} type="checkbox" id={group.groupName}></input>
              }
            <label class="form-check-label" for={group.groupName}>
              {group.groupName}
            </label>
          </div>
        </div>
      )
    }


    //AlertWindow
    let windowAlertHTML;
    if(this.state.alertWindow != ''){
      windowAlertHTML = <AlertWindow title="Changes Saved!" message={this.state.windowAlertHTML} close={this.closeAlertWindow}/>
    }

  return(
      <div>
        {windowAlertHTML}
        <div className='pop-up comments-popup' onClick={this.props.close}></div>
        <div className="container pop-up-window comments-window">
          <div className="row">
              <div className="col-12 container p-4">
                <h3>Editing User: {this.props.id} - {this.props.username}</h3>
              </div>
              <div className="col-12 container p-4">
                <form className="row" onSubmit={this.saveChanges}>
                  <div className="col-auto">
                    <label for="inputPassword2" className="visually-hidden">Password</label>
                    <input onChange={this.handleFormChange} type="password" className="form-control" id="password" placeholder="Password"></input>
                  </div>
                  <div class="row my-3">
                    <h4>Permissions</h4>
                    {listOfGroups}
                  </div>
                    <div className='row'>
                      <div className='col-3'>
                        <button type='submit'>Save changes</button>
                      </div>
                    </div>
                </form>
              </div>
          </div>
        </div>
      </div>
    )
  }
}

export default EditUser;